/**
 * @generated SignedSource<<876a1f57465998edf167a83eb24b4be2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowHooks_useAskCopilotSendMessage_conversation$data = {
  readonly context: {
    readonly name: string;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "AskFellowHooks_useAskCopilotSendMessage_conversation";
};
export type AskFellowHooks_useAskCopilotSendMessage_conversation$key = {
  readonly " $data"?: AskFellowHooks_useAskCopilotSendMessage_conversation$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowHooks_useAskCopilotSendMessage_conversation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowHooks_useAskCopilotSendMessage_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AskCopilotConversationContext",
      "kind": "LinkedField",
      "name": "context",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AskCopilotConversation",
  "abstractKey": null
};

(node as any).hash = "291c57b31f489c574eea19989de3410f";

export default node;
